/**
 *@Description: 针对useState多个创建封装的方法
*/
import {
  useReducer,
  useCallback
} from "react"
import update from "immutability-helper"
import tool from "@/src/utils/tool"

//获取immutability-helper更新表达式
function getUpdateSpec(key:any, value:any) {
  const $spec:any = {}
  if (typeof key == "string") {
    const set = {
      $set: value
    }

    let $spec_cur:any = {}
    const arr = key.split(".")
    if (arr.length == 1) {
      //单个直接set
      $spec[key] = set
    } else {
      for (let index = 0; index < arr.length; index++) {
        const i = arr[index]
        if (index == 0) {
          $spec[i] = {}
        } else {
          $spec_cur = $spec[arr[index - 1]]
          if (index == arr.length - 1) {
            $spec_cur[i] = set
          } else {
            $spec_cur[i] = {}
          }
        }
      }
    }
  } else {
    return key
  }
  return $spec
}


// 自定义useState
function useXState(defaultState:any) {
  const reducer = useCallback((state:any, action:any) => {
    //console.log(action);

    let result:any = {}
    if (action.type == "string") {
      const $spec = getUpdateSpec(action.key, action.value)
      result = update(state, $spec)
    } else if (action.type == "spec") {
      const $spec = action.value
      result = update(state, $spec)
    } else if (action.type == "function") {
      const fn = action.key
      result = tool.deepClone(state)
      fn(result)
       
    } else {
      result = tool.deepClone(state)
      result = { ...state, ...action.value }
    }
    if (action.callback) action.callback(result)

    return result
  },[])

  const [state, dispatch] = useReducer(reducer, defaultState)

  function setState(...arr:any) {
    if (!arr || arr.length < 1) {
      return
    }
    const payload = arr[0]
    let value = undefined
    let callback = undefined
    if (typeof payload == "string") {
      value = arr[1]
      callback = arr[2]
      dispatch({
        type: "string",
        key: payload,
        value: value,
        callback: callback
      })
    } else if (typeof payload == "function") {
      value = payload
      callback = arr[1]
      dispatch({
        type: "function",
        key: payload,
        value: value,
        callback: callback
      })
    } else {
      value = payload
      callback = arr[1]
      dispatch({
        type: "object",
        key: payload,
        value: value,
        callback: callback
      })
    }
  }
  //immutability-helper表达式方式更新
  function setStateBySpec(...arr:any) {
    if (!arr || arr.length < 1) {
      return
    }
    const payload = arr[0]
    let value = undefined
    let callback = undefined
    value = payload
    callback = arr[1]
    dispatch({
      type: "spec",
      key: payload,
      value: value,
      callback: callback
    })
  }

  return [state, setState, setStateBySpec]
}


// function useCallbackState(od) {
//   const cbRef = useRef();

//   const [data, setData] = useState(od);

//   useEffect(() => {
//     cbRef.current && cbRef.current(data);
//   }, [data]);

//   return [
//     data,
//     function (key, value, callback) {
//       cbRef.current = callback;
//       const $spec = getUpdateSpec(key, value);
//       setData(update(data, $spec));
//     },
//     function (d, callback) {
//       cbRef.current = callback;
//       setData(update(data, d));
//     },
//     function (d, callback) {
//       cbRef.current = callback;
//       setData(d);
//     },
//   ];
// }


export default useXState
